angular.module('mychart').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/mychart/views/chartConsent.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-demo\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                <div class=\"panel-subheading panel-flush text-center\">\r" +
    "\n" +
    "                    {{::'Patient Chart Consent' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div id=\"login-consent-panel\" class=\"container-fluid container-flush\">\r" +
    "\n" +
    "                    <div class=\"panel panel-default panel-flush\">\r" +
    "\n" +
    "                        <div class=\"panel-body\">\r" +
    "\n" +
    "                            <form name=\"chartConsentForm\" ng-submit=\"submitForm()\" novalidate>\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                        <div class=\"form-group\">\r" +
    "\n" +
    "                                            <p class=\"form-control-static\" ng-bind-html=\"model.PatientChartConsent.ConsentForm\">\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "                                                {{::model.PatientChartConsent.ConsentForm}}\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                                        <div class=\"form-group\">\r" +
    "\n" +
    "                                            <label for=\"agreeToConsentCheckbox\">\r" +
    "\n" +
    "                                                <input type=\"checkbox\" \r" +
    "\n" +
    "                                                    id=\"agreeToConsentCheckbox\" \r" +
    "\n" +
    "                                                    name=\"agreeToConsentCheckbox\"\r" +
    "\n" +
    "                                                    ng-model=\"ChartConsentVm.agreeToConsentChecked\" \r" +
    "\n" +
    "                                                    required/>\r" +
    "\n" +
    "                                                    &nbsp;&nbsp;{{model.AgreeCheckboxText}}\r" +
    "\n" +
    "                                            </label>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        <div ng-show=\"chartConsentForm.$submitted || chartConsentForm.agreeToConsentCheckbox.$touched\">\r" +
    "\n" +
    "                                            <div ng-show=\"chartConsentForm.agreeToConsentCheckbox.$error.required\"\r" +
    "\n" +
    "                                                 class=\"text-danger\">\r" +
    "\n" +
    "                                                {{model.ConsentWarningMessage}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-1 col-sm-2 col-md-3\">&nbsp;</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                                        <button id=\"disagreeBtn\" type=\"button\" class=\"btn btn-default1 btn-lg btn-block\"\r" +
    "\n" +
    "                                                ng-click=\"disagreeToConsent()\"><i class=\"fa fa-5x\"></i>{{::'Disagree' | translate}}</button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div class=\"col-xs-5 col-sm-4 col-md-3\">\r" +
    "\n" +
    "                                        <button id=\"agreeBtn\" type=\"submit\" class=\"btn btn-primary btn-lg btn-block\">\r" +
    "\n" +
    "                                            <span class=\"ng-hide\" ng-show=\"submitted\">\r" +
    "\n" +
    "                                                <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                                            </span><i class=\"fa fa-5x\"></i>{{::'Agree' | translate}}</button>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    <div class=\"col-xs-1 col-sm-2 col-md-3\">&nbsp;</div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            </form>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "                        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                            {{::'An error has occurred and the chart consent could not be loaded.' | translate}}\r" +
    "\n" +
    "                        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                            {{::'You do not have access to chart consent page.' | translate}}\r" +
    "\n" +
    "                        </uib-alert>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/components/apPrintablePatientInfo.html',
    "<div class=\"visible-print-block\">\r" +
    "\n" +
    "    <div><b>{{::vm.fullName}}</b></div>\r" +
    "\n" +
    "    <ap-date-formatter date=\"{{::vm.birthDate}}\" format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "    <span>({{::vm.age}})</span>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/directives/apImmunizationsCard.html',
    "<div ng-cloak>\r" +
    "\n" +
    "        <table id=\"immunizations-table\" class=\"table table-striped\">\r" +
    "\n" +
    "            <thead>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "                <th>{{::'Vaccine' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Vaccine Type' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Date' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Details' | translate}}</th>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "            </thead>\r" +
    "\n" +
    "            <tbody ng-repeat=\"vaccine in patientImmunizations\">\r" +
    "\n" +
    "            <tr ng-repeat=\"immunization in vaccine.Immunizations track by $index\">\r" +
    "\n" +
    "                <td ng-if=\"$first\" rowspan=\"{{rowSpanCal(vaccine.RoutineDoses, vaccine.Immunizations.length)}}\">\r" +
    "\n" +
    "                    {{::vaccine.Name}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td ng-if=\"immunization.Name\">\r" +
    "\n" +
    "                    {{::immunization.Name}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td ng-if=\"!immunization.Name\">\r" +
    "\n" +
    "                    &nbsp;\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    <span ap-date-formatter date=\"{{::immunization.AdministeredDate}}\"\r" +
    "\n" +
    "                            format=\"short-date\"></span>\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    {{::immunization.Details}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "            </tr>\r" +
    "\n" +
    "            <tr ng-repeat=\"i in getRoutineDoses(vaccine.RoutineDoses, vaccine.Immunizations.length) track by $index\">\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    &nbsp;\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    &nbsp;\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    &nbsp;\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "            </tr>\r" +
    "\n" +
    "            </tbody>\r" +
    "\n" +
    "        </table>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/immunizations.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"immunizations-panel\" class=\"panel panel-default panel-flush table-responsive\"\r" +
    "\n" +
    "         ng-class=\"(modalPrint)?'hidden-print':''\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Immunizations' | translate}}\r" +
    "\n" +
    "            <button class=\"btn btn-default pull-right\" ng-click=\"viewModal()\">{{\"Download Records\" | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "            <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "                <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" id=\"vaccinecardtype-filter-btn\"\r" +
    "\n" +
    "                            uib-dropdown-toggle>\r" +
    "\n" +
    "                        <span>{{'Vaccine Card Type' | translate}}&nbsp;&nbsp;</span>\r" +
    "\n" +
    "                        <span class=\"title-text\">{{model.SelectedVaccineCard.Name | translate}}</span>\r" +
    "\n" +
    "                        <span class=\"caret\"></span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"messageSubTypeFilter\">\r" +
    "\n" +
    "                        <li class=\"clickable\" role=\"presentation\" ng-repeat=\"vaccineCard in model.VaccineCardList\">\r" +
    "\n" +
    "                            <a id=\"vaccinecardtype-filter-item-{{vaccineCard.Id}}\" ng-if=\"vaccineCard\" role=\"menuitem\"\r" +
    "\n" +
    "                               ng-click=\"loadVaccineCard(vaccineCard)\">{{::vaccineCard.Name | translate}}</a>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div id=\"immunizations-table\" ng-if=\"!loadingVaccineCard && !httpError\">\r" +
    "\n" +
    "            <ap-immunizations-card\r" +
    "\n" +
    "                    patient-immunizations=\"model.PatientImmunizations\">\r" +
    "\n" +
    "            </ap-immunizations-card>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loadingVaccineCard\" class=\"text-center\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loadingStartup || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and immunizations could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/labResults.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"lab-results-panel\" class=\"panel panel-default panel-flush\" ng-class=\"(isModalDisplayed)?'hidden-print':''\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Test Results' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"table-responsive\">\r" +
    "\n" +
    "            <div ng-if=\"!labResults.length\">\r" +
    "\n" +
    "                {{::'No Test Results' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <table id=\"lab-results-table\" class=\"table table-striped\" ng-if=\"labResults.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                    <tr>\r" +
    "\n" +
    "                        <th>{{::\"Order Date\" | translate}}</th>\r" +
    "\n" +
    "                        <th>{{::\"Description\" | translate}}</th>\r" +
    "\n" +
    "                        <th>{{::\"Result Date\" | translate}}</th>\r" +
    "\n" +
    "                        <th>{{::\"Results\" | translate}}</th>\r" +
    "\n" +
    "                        <th></th>\r" +
    "\n" +
    "                    </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "                <tbody ng-repeat=\"labResult in labResults track by $index\" ng-if=\"labResult\">\r" +
    "\n" +
    "                    <tr ng-repeat=\"attachmentInfo in labResult.AttachmentInfos track by $index\">\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{labResult.Result.OrderDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div class=\"column-text\">{{::labResult.Result.Description}}</div>\r" +
    "\n" +
    "                            <div class=\"column-subtext\">{{::labResult.Result.AttachmentType}}</div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{::labResult.Result.ResultDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-1 col-flush\">\r" +
    "\n" +
    "                                    <i class=\"fa fa-file fa-lg\"></i>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-11 col-flush float-left\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-text\">\r" +
    "\n" +
    "                                        <a ng-click=\"viewLabResultAttachment(labResult.Result.Description, attachmentInfo)\"><u>{{::'View Results' | translate}}</u></a>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-subtext\">\r" +
    "\n" +
    "                                        {{::attachmentInfo.Extension | uppercase}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <button ap-save-to-file=\"downloadLabResultAttachment(labResult.Result.Description, attachmentInfo)\"\r" +
    "\n" +
    "                                    ><i ng-show=\"!attachmentInfo.Downloading\" class=\"fa fa-download\"></i><ap-spinner ng-show=\"attachmentInfo.Downloading\"></ap-spinner></button>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                    </tr>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <tr ng-if=\"labResult.AttachmentInfos.length <= 0\">\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{labResult.Result.OrderDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div class=\"column-text\">{{::labResult.Result.Description}}</div>\r" +
    "\n" +
    "                            <div class=\"column-subtext\">{{::labResult.Result.AttachmentType}}</div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{::labResult.Result.ResultDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-1 col-flush\">\r" +
    "\n" +
    "                                    <i class=\"fa fa-file fa-lg\"></i>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-11 col-flush float-left\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-text\">\r" +
    "\n" +
    "                                        <a ng-click=\"viewLabResultObservation(labResult.Result.Description, labResult.Result.Id)\"><u>{{::'View Results' | translate}}</u></a>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-subtext\">\r" +
    "\n" +
    "                                        {{ 'PDF' | uppercase}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <button ap-save-to-file=\"downloadLabResultObservation(labResult.Result)\"\r" +
    "\n" +
    "                                    ><i ng-show=\"!labResult.Result.Downloading\" class=\"fa fa-download\"></i><ap-spinner ng-show=\"labResult.Result.Downloading\"></ap-spinner></button>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                    </tr>\r" +
    "\n" +
    "                </tbody>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s info.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/loadingDocument.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Loading Document' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-center\">\r" +
    "\n" +
    "            <p>{{::'You will be redirected shortly...'| translate}}</p>\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/medicationAllergies.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-default panel-flush table-responsive\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Medication Allergies' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!model.MedicationAllergies.length && !loading && !httpError\">\r" +
    "\n" +
    "            {{::'There are no Medication Allergies' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <table ng-if=\"model.MedicationAllergies.length && !loading && !httpError\" class=\"table table-striped\">\r" +
    "\n" +
    "            <thead>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "                <th>{{::'Record Date' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Allergen' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Reaction' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Notes' | translate}}</th>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "            </thead>\r" +
    "\n" +
    "            <tbody>\r" +
    "\n" +
    "            <tr ng-repeat=\"group in model.MedicationAllergies track by $index\" ng-if=\"group.Allergen\">\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    <span ap-date-formatter date=\"{{::group.PatientMedicationAllergy[0].RecordDateTime}}\"\r" +
    "\n" +
    "                          format=\"short-date\" ng-if=\"group.PatientMedicationAllergy[0]\"></span>\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    {{::group.Allergen}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    <span ng-repeat=\"item in group.PatientMedicationAllergy track by $index\" ng-if=\"item.Reaction\">{{::item.Reaction}}<span ng-if=\"!$last\">,&nbsp;</span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    <span ng-repeat=\"item in group.PatientMedicationAllergy track by $index\" ng-if=\"item.Notes\">{{::item.Notes}}<span ng-if=\"!$last\">,&nbsp;</span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "            </tr>\r" +
    "\n" +
    "            </tbody>\r" +
    "\n" +
    "        </table>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and medication allergies could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/genericModal.html',
    "<div class=\"modal-body\" ng-bind-html=\"modalContent\">\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div ng-class=\"{'col-xs-3': !canPrint, 'col-xs-1': canPrint }\"></div>\r" +
    "\n" +
    "        <div class=\"col-xs-5\" ng-if=\"canPrint\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"btn btn-default\" ng-click=\"print()\">\r" +
    "\n" +
    "                {{::'Print' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-class=\"{'col-xs-6': !canPrint, 'col-xs-5': canPrint }\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ok()\">\r" +
    "\n" +
    "                {{::'Close' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-class=\"{'col-xs-3': !canPrint, 'col-xs-1': canPrint }\"></div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/mobile/immunizations.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"immunizations-panel\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable pull-right\"\r" +
    "\n" +
    "                     ng-click=\"(tileState.isCollapsed === undefined) || viewModal()\">\r" +
    "\n" +
    "                    <i class=\"fa fa-save\" ng-show=\"tileState.isCollapsed !== undefined\"></i>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable pull-right\">\r" +
    "\n" +
    "                <span class=\"header-menu\">\r" +
    "\n" +
    "                    <div class=\"dropdown-primary\" uib-dropdown ng-show=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default btn-icon btn-nowrap\" type=\"button\" id=\"vaccinecardtype-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                            <i class=\"fa fa-filter\" />\r" +
    "\n" +
    "                            <span class=\"caret\"></span>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"messageSubTypeFilter\">\r" +
    "\n" +
    "                            <li class=\"clickable\" role=\"presentation\" ng-repeat=\"vaccineCard in model.VaccineCardList\" ng-if=\"vaccineCard.Name\">\r" +
    "\n" +
    "                                <a id=\"vaccinecardtype-filter-item-{{vaccineCard.Id}}\" ng-if=\"vaccineCard.Name\" role=\"menuitem\"\r" +
    "\n" +
    "                                   ng-click=\"loadVaccineCard(vaccineCard); tileState.isCollapsed = false;\"><span><i class=\"fa fa-filter\" ng-if=\"model.SelectedVaccineCard.Name == vaccineCard.Name\" />&nbsp;{{::vaccineCard.Name | translate}}</span></a>\r" +
    "\n" +
    "                            </li>\r" +
    "\n" +
    "                        </ul>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loadingVaccineCard\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Immunizations' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loadingVaccineCard && !model.ImmunizationsExist\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'There are no Immunizations' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined && model.ImmunizationsExist\" ng-repeat=\"patientImmunization in model.PatientImmunizations track by patientImmunization.Id\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"$index == 0\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>{{::'Date' | translate }}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Immunization Name' | translate }}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Vaccine Name' | translate }}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Details' | translate }}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"immunization in patientImmunization.Immunizations track by $index\" ng-if=\"immunization.AdministeredDate\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{::immunization.AdministeredDate}}\" format=\"short-date\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content\">\r" +
    "\n" +
    "                        <div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::patientImmunization.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::immunization.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::immunization.Details}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and immunizations could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/labResults.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"lab-results-panel\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Test Results' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && !labResults.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'No Test Results' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && labResults.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"labResults.length\">\r" +
    "\n" +
    "                    <div class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                            <span>{{::'Download' | translate }}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div>{{::'Order' | translate }}</div>\r" +
    "\n" +
    "                            <div>{{::'Date' | translate }}</div>\r" +
    "\n" +
    "                            <div>{{::'Result' | translate }}</div>\r" +
    "\n" +
    "                            <div>{{::'Date' | translate }}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Description' | translate }}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"labResult in labResults track by $index\" class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-right\" ng-init=\"attachmentInfo = labResult.AttachmentInfos[0]\">\r" +
    "\n" +
    "                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                            <span class=\"clickable\" ng-if=\"attachmentInfo\" ng-click=\"viewLabResultAttachment(labResult.Result.Description, attachmentInfo)\"><i class=\"fa fa-download fa-2x\"></i></span>\r" +
    "\n" +
    "                            <button ap-save-to-file=\"downloadLabResultObservation(labResult.Result)\">\r" +
    "\n" +
    "                                <i ng-show=\"!labResult.Result.Downloading\" class=\"fa fa-download\"></i>\r" +
    "\n" +
    "                                <ap-spinner ng-show=\"labResult.Result.Downloading\"></ap-spinner>\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::labResult.Result.OrderDate}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::labResult.Result.ResultDate}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content\">\r" +
    "\n" +
    "                        <div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::labResult.Result.Description}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::labResult.Result.AttachmentType}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/medicationAllergies.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"medication-allergies-panel-mobile\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Medication Allergies' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && model.MedicationAllergies.length == 0\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'There are no Medication Allergies' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"model.MedicationAllergies.length\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                            <span>{{::'Notes' | translate }}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div>{{::'Record' | translate}}</div>\r" +
    "\n" +
    "                            <div>{{::'Date' | translate}}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Disease' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Reaction' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"group in model.MedicationAllergies track by $index\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <span ng-repeat=\"item in group.PatientMedicationAllergy track by $index\" ng-if=\"item.Notes\">\r" +
    "\n" +
    "                            {{::item.Notes}}\r" +
    "\n" +
    "                            <span ng-if=\"!$last\">,&nbsp;</span>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{::group.PatientMedicationAllergy[0].RecordDateTime}}\"\r" +
    "\n" +
    "                                  format=\"short-date\" ng-if=\"group.PatientMedicationAllergy[0]\"></span>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content\">\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::group.Allergen}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                            <span ng-repeat=\"item in group.PatientMedicationAllergy track by $index\" ng-if=\"item.Reaction\">\r" +
    "\n" +
    "                        {{::item.Reaction}}\r" +
    "\n" +
    "                    <span ng-if=\"!$last\">,&nbsp;</span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and medication allergies could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/personalDetails.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <form name=\"editPatientDetailsForm\" ng-submit=\"saveUpdateDetailsRequest(this.editPatientDetailsForm)\" novalidate>\r" +
    "\n" +
    "        <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "            <div id=\"patient-details-panel\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                        <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                            <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                            <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"clickable pull-right\" ng-show=\"config.UpdateDemographics.IsActive\"\r" +
    "\n" +
    "                         ng-click=\"(tileState.isCollapsed === undefined) || saving || (edit ? cancelEdit() : editDetails())\">\r" +
    "\n" +
    "                        <i class=\"fa\" ng-class=\"{'fa-pencil': !edit, 'fa-undo': edit}\" ng-show=\"tileState.isCollapsed !== undefined\"></i>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"clickable pull-right\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default btn-icon\" type=\"submit\" ng-hide=\"(tileState.isCollapsed === undefined) || saving || !edit\">\r" +
    "\n" +
    "                            <i class=\"fa fa-save\"></i>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                        <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                            <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <span class=\"panel-title\">{{::'Personal Details' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div ng-include=\"'/mychart/views/personalDetailsCommon.html'\" ng-if=\"tileState.isCollapsed !== undefined\" uib-collapse=\"tileState.isCollapsed\" />\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/prescriptionsList.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"prescriptions-panel-mobile\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable pull-right\">\r" +
    "\n" +
    "                <span class=\"header-menu\">\r" +
    "\n" +
    "                    <div class=\"dropdown-primary\" uib-dropdown ng-show=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default btn-nowrap btn-icon\" type=\"button\" id=\"recent-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                            <i class=\"fa fa-filter\" />\r" +
    "\n" +
    "                            <span class=\"caret\"></span>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"daysFilter\">\r" +
    "\n" +
    "                            <li class=\"clickable\" role=\"presentation\" ng-repeat=\"medFilter in medFilters\">\r" +
    "\n" +
    "                                <a id=\"day-filter-item-{{medFilter.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                                   ng-click=\"updateFilteredPrescriptions(medFilter); tileState.isCollapsed = false;\"><span><i class=\"fa fa-filter\" ng-if=\"activeFilter.Name == medFilter.Name\" />&nbsp;{{::medFilter.Name | translate}}</span></a>\r" +
    "\n" +
    "                            </li>\r" +
    "\n" +
    "                        </ul>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Prescriptions' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && !filteredPrescriptions.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'No prescriptions' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"filteredPrescriptions.length\">\r" +
    "\n" +
    "                    <div ng-if=\"featureList.RequestRxRefills.IsActive\" class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                            <span>{{::'Refill' | translate }}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div>{{::'Status' | translate}}</div>\r" +
    "\n" +
    "                            <div>{{::'Duration' | translate}}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Drug + Directions' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"med in filteredPrescriptions track by med.RelPatientMedicationId\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div ng-if=\"featureList.RequestRxRefills.IsActive && !med.IsDiscontinued\" class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <span class=\"clickable\">\r" +
    "\n" +
    "                            <button class=\"btn btn-default\" data-transition-to=\"{appRoute: 'rxrefill'}\" ng-click=\"medSelect(med)\">\r" +
    "\n" +
    "                                <i class=\"fa fa-medkit fa-2x\"></i>\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div><span>{{::med.IsActive ? dateDiff(med.EndDate) : ''}}</span></div>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::med.StartDate}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "                            <div><span>-</span></div>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-if=\"med.RefillRequestPending && !med.IsDiscontinued\"><span>{{::'Pending Review' | translate}}</span></div>\r" +
    "\n" +
    "                            <div ng-if=\"med.IsDiscontinued\"><span>{{::'Discontinued' | translate}}</span></div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content clickable\" ng-click=\"viewModal(med.RelPatientMedicationId)\">\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::med.DrugName}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-wrap\">\r" +
    "\n" +
    "                            {{::med.Instructions}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient medications could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s medications.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/problems.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"problems-panel-mobile\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable pull-right\">\r" +
    "\n" +
    "                <span class=\"header-menu\">\r" +
    "\n" +
    "                    <div class=\"dropdown-primary\" uib-dropdown ng-show=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default btn-icon btn-nowrap\" type=\"button\" id=\"active-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                            <i class=\"fa fa-filter\" />\r" +
    "\n" +
    "                            <span class=\"caret\"></span>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"activeFilter\">\r" +
    "\n" +
    "                            <li class=\"clickable\" role=\"presentation\" ng-repeat=\"activeFilter in activeFilters\">\r" +
    "\n" +
    "                                <a id=\"active-filter-item-{{activeFilter.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                                   ng-click=\"update(activeFilter.Id); tileState.isCollapsed = false;\"><span><i class=\"fa fa-filter\" ng-if=\"problem.activeName == activeFilter.Name\" />&nbsp;{{::activeFilter.Name | translate}}</span></a>\r" +
    "\n" +
    "                            </li>\r" +
    "\n" +
    "                        </ul>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Problems' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && filteredProblems.length == 0\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'No problems have been entered' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"filteredProblems.length\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div>{{::'Status' | translate}}</div>\r" +
    "\n" +
    "                            <div>{{::'Duration' | translate}}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Disease' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Notes' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"prob in filteredProblems track by $index\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div><span>{{prob.IsActive ? ('Active' | translate) : ('Not Active' | translate)}}</span></div>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::prob.Date}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "                            <div><span>-</span></div>\r" +
    "\n" +
    "                            <div><span ng-if=\"prob.Duration\" ap-date-formatter date=\"{{::prob.Duration}}\" format=\"short-date\"></span><span ng-if=\"!prob.Duration\">-----</span></div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content\">\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::prob.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::prob.Notes}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/procedures.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"procedures-panel-mobile\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Procedures' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && !procedures.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'There are no procedures' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"procedures.length\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div>{{::'Date' | translate}}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Procedure' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                                {{::'Description' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"proc in procedures track by $index\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div><span ap-date-formatter date=\"{{::proc.VisitDate}}\" format=\"short-date\"></span></div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content clickable\" ng-click=\"viewModal(proc.Id)\">\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::proc.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-wrap\">\r" +
    "\n" +
    "                            {{::proc.Description}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/referenceMaterial.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"reference-material-panel-mobile\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-show=\"tileState.isCollapsed !== false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-show=\"tileState.isCollapsed === false\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable pull-right\">\r" +
    "\n" +
    "                    <span class=\"header-menu\">\r" +
    "\n" +
    "                        <div class=\"dropdown-primary\" uib-dropdown ng-show=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                            <button class=\"btn btn-default btn-icon btn-nowrap\" type=\"button\" id=\"language-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                                <i class=\"fa fa-filter\" />\r" +
    "\n" +
    "                                <span class=\"caret\"></span>\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                            <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"languageFilter\">\r" +
    "\n" +
    "                                <li class=\"clickable\" role=\"presentation\" ng-repeat=\"language in model.LanguageOptions\">\r" +
    "\n" +
    "                                    <a id=\"language-filter-item-{{language.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                                    ng-click=\"updateActiveLanguage(language, true)\"><span><i class=\"fa fa-filter\" ng-if=\"model.ActiveLanguage.Description == language.Description\" />&nbsp;{{::language.Description | translate}}</span></a>\r" +
    "\n" +
    "                                </li>\r" +
    "\n" +
    "                            </ul>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"toggleState()\">\r" +
    "\n" +
    "                    <div class=\"pull-right ng-hide\" ng-show=\"loading\">\r" +
    "\n" +
    "                        <ap-spinner></ap-spinner>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Educational Material' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\" ng-show=\"!loading && !model.EducationalMaterial.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'No Reference Material found.' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-if=\"tileState.isCollapsed !== undefined\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\" ng-if=\"model.EducationalMaterial.length\">\r" +
    "\n" +
    "                    <div class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <span>{{::'View Form' | translate }}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">{{::'Description' | translate}}</div>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading overflow-ellipsis\">{{::'Available Languages' | translate}}</div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"formGroup in model.EducationalMaterial track by $index\"\r" +
    "\n" +
    "                    class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <span class=\"clickable\">\r" +
    "\n" +
    "                            <button class=\"btn btn-default1\" ng-click=\"viewReferenceMaterial(formGroup.GroupName, formGroup.Forms)\">\r" +
    "\n" +
    "                                <i class=\"fa fa-file fa-2x\"></i>\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                            <div class=\"list-item-sub-heading\">{{::formGroup.GroupName | translate}}</div>\r" +
    "\n" +
    "                            <div class=\"list-item-details\"><span ng-repeat=\"refForm in formGroup.Forms track by $index\">{{::refForm.Language.Description | translate}}<span\r" +
    "\n" +
    "                                ng-if=\"!$last\">,&nbsp;</span></span></div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/mobile/visitSummary.html',
    "<div class=\"row\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "        <div id=\"visit-summary-panel\" class=\"panel panel-tile-secondary\">\r" +
    "\n" +
    "            <div class=\"panel-heading\">\r" +
    "\n" +
    "                <div class=\"clickable pull-right\" ng-click=\"tileState.isCollapsed = !tileState.isCollapsed\">\r" +
    "\n" +
    "                    <div class=\"pull-right panel-collapser\">\r" +
    "\n" +
    "                        <span ng-if=\"tileState.isCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-expand\" alt=\"tile-expand\"></span>\r" +
    "\n" +
    "                        <span ng-if=\"!tileState.isCollapsed\"><img src=\"images/spacer.png\" class=\"tile-arrow tile-collapse\" alt=\"tile-collapse\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"clickable\" ng-click=\"tileState.isCollapsed = !tileState.isCollapsed\">\r" +
    "\n" +
    "                    <span class=\"panel-title\">{{::'Visit Summary' | translate}}</span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-show=\"!loading && !visits.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 text-center-vert text-center\">\r" +
    "\n" +
    "                        <span>{{::'No completed Visit Summaries were found' | translate}}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "            <ul class=\"list-group list-group-fixed-height\" uib-collapse=\"tileState.isCollapsed\" ng-show=\"!loading && visits.length\">\r" +
    "\n" +
    "                <li class=\"list-group-item list-group-header\">\r" +
    "\n" +
    "                    <div class=\"list-item-col2-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <span>{{::'Download' | translate }}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-col-sm list-item-sub-heading overflow-ellipsis text-center-vert pull-left\">\r" +
    "\n" +
    "                        <span>{{::'Date' | translate }}</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content text-center-vert\">\r" +
    "\n" +
    "                        <span>\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::'Clinical Note Type' | translate }}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::'Diagnoses' | translate }}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::'Provider' | translate }}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "                <li ng-repeat=\"visit in visits track by $index\" class=\"list-group-item\">\r" +
    "\n" +
    "                    <div class=\"list-item-col-xs list-item-sub-heading overflow-ellipsis text-center-vert pull-right\">\r" +
    "\n" +
    "                        <div class=\"text-center-vert pull-right\">\r" +
    "\n" +
    "                            <span class=\"clickable\" ng-click=\"viewVisitSummary(visit.VisitId, visit.Date)\"><i class=\"fa fa-download fa-2x\"></i></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"text-center-vert list-item-col-sm list-item-time pull-left\">\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{::visit.Date}}\" format=\"short-date\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"list-item-content\">\r" +
    "\n" +
    "                        <div class=\"list-item-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::visit.ClinicalNoteTypeName}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-sub-heading overflow-ellipsis\">\r" +
    "\n" +
    "                            <div ng-repeat=\"diagnosisName in ::visit.Diagnosis\">{{::diagnosisName}}</div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"list-item-details overflow-ellipsis\">\r" +
    "\n" +
    "                            {{::visit.Provider}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </li>\r" +
    "\n" +
    "            </ul>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"httpError\">\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/modals/ccdAccessLog.html',
    "<div class=\"modal-default\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Access Log' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body modal-max-height\">\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !model.AccessLog.length\">\r" +
    "\n" +
    "            {{::'No logs found.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <table ng-if=\"!loading && model.AccessLog.length\" class=\"table table-striped table-flush\">\r" +
    "\n" +
    "            <thead>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "                <th>{{::'Disclosure Date' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Patient' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Portal Login Name' | translate}}</th>\r" +
    "\n" +
    "                <th>{{::'Disclosure Purpose' | translate}}</th>\r" +
    "\n" +
    "            <tr>\r" +
    "\n" +
    "            </thead>\r" +
    "\n" +
    "            <tbody>\r" +
    "\n" +
    "            <tr ng-repeat=\"log in model.AccessLog\">\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    <span ap-date-formatter date=\"{{::log.DisclosureDatetime}}\" format=\"short-date\"></span>\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    {{::log.DisclosedByName}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    {{::log.PortalLoginName}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "                <td>\r" +
    "\n" +
    "                    {{::log.DisclosurePurpose}}\r" +
    "\n" +
    "                </td>\r" +
    "\n" +
    "            </tr>\r" +
    "\n" +
    "            </tbody>\r" +
    "\n" +
    "        </table>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-lg text-center\" ng-click=\"ok()\">\r" +
    "\n" +
    "            {{::'Close' | translate}}\r" +
    "\n" +
    "        </button>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/ccdTransmit.html',
    "<div class=\"modal-default\">\r" +
    "\n" +
    "    <form name=\"transmitCcdForm\" ng-submit=\"submitTransferRequest()\" novalidate>\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{'Transmit CCD' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "        <div class=\"modal-body\" ng-if=\"!loading\">\r" +
    "\n" +
    "            <div class=\"text-center has-error\" ng-if=\"!isConfigured\">\r" +
    "\n" +
    "                {{'Transmit feature is disabled. The transmit feature has not been configured.'}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"SendType\">{{::'Type' | translate}}</label>\r" +
    "\n" +
    "                                <select\r" +
    "\n" +
    "                                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"SendType\"\r" +
    "\n" +
    "                                        id=\"SendType\"\r" +
    "\n" +
    "                                        ng-model=\"model.SendType\"\r" +
    "\n" +
    "                                        ng-options=\"item.Type for item in model.SendTypeList | filter:{Enabled:true}\"\r" +
    "\n" +
    "                                        ap-required=true>\r" +
    "\n" +
    "                                </select>\r" +
    "\n" +
    "                        <div ng-show=\"model.SendType.Type === 'Email'\">\r" +
    "\n" +
    "                            {{::'Email over the internet is not secure. Information in an email, including attachments, can be intercepted and read by parties other than the person to whom it is addressed.' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"form-group\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div class=\"form-group\" ng-show=\"model.SendType.Type !== 'Email'\">\r" +
    "\n" +
    "                            <label class=\"control-label\" for=\"fromProvider\">{{::'From User' | translate}}</label>\r" +
    "\n" +
    "                                <input class=\"form-control\"\r" +
    "\n" +
    "                                    name=\"DirectMailUser\"\r" +
    "\n" +
    "                                    id=\"fromProvider\"\r" +
    "\n" +
    "                                    ng-model=\"model.DirectMailUser.FullName\"\r" +
    "\n" +
    "                                    type=\"text\"\r" +
    "\n" +
    "                                    ng-disabled=\"true\"\r" +
    "\n" +
    "                                    ap-required=\"model.SendType.Type !== 'Email'\">\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"form-group\" ng-show=\"model.SendType.Type === 'Email'\">\r" +
    "\n" +
    "                            <label class=\"control-label\" for=\"directMailAddress\">{{::'To Name' | translate}}</label>\r" +
    "\n" +
    "                                <input class=\"form-control\"\r" +
    "\n" +
    "                                        name=\"ToName\"\r" +
    "\n" +
    "                                        id=\"toName\"\r" +
    "\n" +
    "                                        ng-model=\"model.ToName\"\r" +
    "\n" +
    "                                        type=\"text\"\r" +
    "\n" +
    "                                        ap-required=\"model.SendType.Type === 'Email'\">\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"form-group\" ng-show=\"model.SendType.Type !== 'Email'\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"directMailAddress\">{{::'To Direct Mail Address' | translate}}</label>\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"DirectMailAddressTo\"\r" +
    "\n" +
    "                                   id=\"directMailAddress\"\r" +
    "\n" +
    "                                   ng-model=\"model.DirectMailAddressTo\"\r" +
    "\n" +
    "                                   type=\"text\"\r" +
    "\n" +
    "                                   ap-required=\"model.SendType.Type !== 'Email'\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"form-group\" ng-show=\"model.SendType.Type === 'Email'\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"directMailAddress\">{{::'Email' | translate}}</label>\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"Email\"\r" +
    "\n" +
    "                                   id=\"email\"\r" +
    "\n" +
    "                                   ng-model=\"model.Email\"\r" +
    "\n" +
    "                                   type=\"text\"\r" +
    "\n" +
    "                                   ap-required=\"model.SendType.Type === 'Email'\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"documentType\">{{::'Document Type' | translate}}</label>\r" +
    "\n" +
    "                                <select\r" +
    "\n" +
    "                                        class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                        name=\"DocumentType\"\r" +
    "\n" +
    "                                        id=\"documentType\"\r" +
    "\n" +
    "                                        ng-model=\"model.DocumentType\"\r" +
    "\n" +
    "                                        ng-options=\"item.Type for item in model.DocumentTypeList\"\r" +
    "\n" +
    "                                        ap-required>\r" +
    "\n" +
    "                                </select>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"subject\">{{::'Subject' | translate}}</label>\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"Subject\"\r" +
    "\n" +
    "                                   id=\"subject\"\r" +
    "\n" +
    "                                   ng-model=\"model.Subject\"\r" +
    "\n" +
    "                                   type=\"text\"\r" +
    "\n" +
    "                                   ap-required>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\" for=\"messageInput\">{{::'Message' | translate}}</label>\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"Message\"\r" +
    "\n" +
    "                                   id=\"messageInput\"\r" +
    "\n" +
    "                                   ng-model=\"model.Message\"\r" +
    "\n" +
    "                                   type=\"text\"\r" +
    "\n" +
    "                                   ap-required>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"modal-footer\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"submit\" class=\"btn btn-primary btn-lg\"\r" +
    "\n" +
    "                    ng-disabled=\"loading || transmitting || !isConfigured\">\r" +
    "\n" +
    "                        <span class=\"ng-hide\" ng-show=\"transmitting\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                        {{::'Submit' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default btn-lg\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                        {{::'Cancel' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/completeChartModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header hidden-print\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">\r" +
    "\n" +
    "            <span ng-if=\"loadingCompleteChart\">\r" +
    "\n" +
    "                {{::'Downloading patient chart for ' | translate}} {{model.FullName}}\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "            <span ng-if=\"!loadingCompleteChart\">\r" +
    "\n" +
    "                {{::'Patient chart for ' | translate }} {{model.FullName}}\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"loadingCompleteChart || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingCompleteChart\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loadingCompleteChart && !isCompleteChartError\" id=\"my-complete-chart\" name=\"my-complete-chart\">\r" +
    "\n" +
    "            <iframe ng-src=\"{{model.CompleteChartData}}\"></iframe>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loadingCompleteChart && (httpError || isCompleteChartError)\">\r" +
    "\n" +
    "            <uib-alert ng-show=\"!isCompleteChartError\" type=\"danger\">{{::'An error has occurred generating the patient chart and could not be loaded.' | translate}}</uib-alert>\r" +
    "\n" +
    "            <uib-alert ng-show=\"httpError.is403\" type=\"danger\">{{::'You do not have access to download the patient chart.' | translate}}</uib-alert>\r" +
    "\n" +
    "            <div ng-show=\"!loadingCompleteChart && isCompleteChartError\" name=\"complete-chart-error-div\">\r" +
    "\n" +
    "                <div ng-bind-html=\"model.CompleteChartErrorMessageHtml\"></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "            <div ng-if=\"displayPrintButton\">\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"print()\">\r" +
    "\n" +
    "                        {{::'Print' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                        {{::'Close' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"!displayPrintButton\">\r" +
    "\n" +
    "                <div class=\"col-xs-8\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                        {{::'Close' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\"\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/immunizationModal.html',
    "<div class=\"modal-body\">\r" +
    "\n" +
    "    <ap-printable-practice-info></ap-printable-practice-info>\r" +
    "\n" +
    "    <ap-printable-patient-info></ap-printable-patient-info>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"!model.PatientImmunizations.length\">\r" +
    "\n" +
    "        {{::'There are no Immunizations' | translate}}\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"model.PatientImmunizations.length\">\r" +
    "\n" +
    "        <ap-immunizations-card\r" +
    "\n" +
    "                patient-immunizations=\"model.PatientImmunizations\">\r" +
    "\n" +
    "        </ap-immunizations-card>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "    <div class=\"row\">\r" +
    "\n" +
    "        <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "        <div class=\"col-xs-4\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"print()\">\r" +
    "\n" +
    "                {{::'Print' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-4\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"btn btn-default btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                {{::'Close' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/labResultPrintDownloadModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header hidden-print\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{attachmentInfo.Description}} : {{attachmentInfo.Name}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"loadingLabResult || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingLabResult\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loadingLabResult && (isImage || isHtml || isText)\" id=\"my-lab-result\" name=\"my-lab-result\">\r" +
    "\n" +
    "            <iframe ng-src=\"{{model.LabResultData}}\">\r" +
    "\n" +
    "            </iframe>\r" +
    "\n" +
    "            <div class=\"text-center\">\r" +
    "\n" +
    "              <span>{{'Unable to view? Download ' | translate}}<a\r" +
    "\n" +
    "                      ap-save-pdf-to-file=\"{{model.ByteArray}}\"\r" +
    "\n" +
    "                      file-name=\"{{model.PdfFileName}}\"\r" +
    "\n" +
    "                      content-type=\"{{model.ContentType}}\">{{'here.' | translate}}</a></span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-show=\"!isHtml && !isText && !isImage && !loadingAttachment && !$root.httpError\" name=\"viewer-unsupported\">\r" +
    "\n" +
    "            <span ng-show=\"attachmentInfo.Extension\" class=\"warning\">{{::'Attachment type is not supported' | translate}} ({{attachmentInfo.Extension}}).</span>\r" +
    "\n" +
    "            <span ng-show=\"!attachmentInfo.Extension\" class=\"warning\">{{::'Attachment type is not known and cannot be displayed.' | translate}}</span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "                <div ng-if=\"displayPrintButton\">\r" +
    "\n" +
    "                    <div class=\"col-xs-4\">\r" +
    "\n" +
    "                        <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"print()\">\r" +
    "\n" +
    "                            {{::'Print' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-4\">\r" +
    "\n" +
    "                        <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                            {{::'Close' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"!displayPrintButton\">\r" +
    "\n" +
    "                    <div class=\"col-xs-8\">\r" +
    "\n" +
    "                        <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                            {{::'Close' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\"\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/observationOrderPrintDownloadModal.html',
    "<div class=\"modal-dialog-report\">\r" +
    "\n" +
    "    <div class=\"modal-header hidden-print\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{resultInfo.Description}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-body\">\r" +
    "\n" +
    "        <div ng-if=\"loadingLabResult || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingLabResult\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loadingLabResult\" id=\"my-observation-order-result\" name=\"my-observation-order-result\">\r" +
    "\n" +
    "            <iframe ng-src=\"{{model.ObservationOrderData}}\">\r" +
    "\n" +
    "            </iframe>\r" +
    "\n" +
    "            <div class=\"text-center\">\r" +
    "\n" +
    "              <span>{{'Unable to view? Download ' | translate}}<a\r" +
    "\n" +
    "                      ap-save-pdf-to-file=\"{{model.ByteArray}}\"\r" +
    "\n" +
    "                      file-name=\"{{model.PdfFileName}}\"\r" +
    "\n" +
    "                      content-type=\"{{model.ContentType}}\">{{'here.' | translate}}</a></span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"modal-footer hidden-print\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "            <div ng-if=\"displayPrintButton\">\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"print()\">\r" +
    "\n" +
    "                        {{::'Print' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default2 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                        {{::'Close' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"!displayPrintButton\">\r" +
    "\n" +
    "                <div class=\"col-xs-8\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default1 btn-lg\" ng-click=\"ok()\">\r" +
    "\n" +
    "                        {{::'Close' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\"\r" +
    "\n" +
    "            <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/modals/pharmacySearch.html',
    "<div class=\"modal-default\">\r" +
    "\n" +
    "    <div class=\"modal-header\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "        <span class=\"modal-subtitle\">{{::'Preferred Pharmacy' | translate}}</span>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-body modal-max-height\">\r" +
    "\n" +
    "            <label class=\"control-label\">{{::'Current:' | translate}}</label>\r" +
    "\n" +
    "            <div class=\"row\" id=\"currentPharmaciesList\" ng-repeat=\"pharmacy in pharmacies track by $index\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-md-2\">\r" +
    "\n" +
    "                    {{pharmacy.Name}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-md-3\">\r" +
    "\n" +
    "                    <div>{{pharmacy.Address.Address1}}</div>\r" +
    "\n" +
    "                    <div>{{pharmacy.Address.Address2}}</div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-2 col-md-1\">\r" +
    "\n" +
    "                    {{pharmacy.Address.State}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-3 col-md-2\">\r" +
    "\n" +
    "                    {{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-4 col-md-2\">\r" +
    "\n" +
    "                    {{pharmacy.Phone.PhoneNumber | tel}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-3 col-md-2\" ng-click=\"removePharmacy($index)\">\r" +
    "\n" +
    "                    <i class=\"fa fa-minus-circle\"></i>&nbsp;{{::'Remove' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6\">\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"searchZip\"\r" +
    "\n" +
    "                           name=\"searchZip\"\r" +
    "\n" +
    "                           ng-model=\"searchPharmaciesParams.Zip\"\r" +
    "\n" +
    "                           type=\"text\"\r" +
    "\n" +
    "                           ng-change=\"submitZip()\"\r" +
    "\n" +
    "                           placeholder=\"Zip Code\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6\">\r" +
    "\n" +
    "                    <input class=\"form-control\"\r" +
    "\n" +
    "                           id=\"searchPhoneNumber\"\r" +
    "\n" +
    "                           name=\"searchPhoneNumber\"\r" +
    "\n" +
    "                           ng-model=\"searchPharmaciesParams.PhoneNumber\"\r" +
    "\n" +
    "                           type=\"text\"\r" +
    "\n" +
    "                           ng-change=\"submitPhoneNumber()\"\r" +
    "\n" +
    "                           placeholder=\"Phone Number\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <button id=\"search-pharmacies-btn\" class=\"btn btn-default1\" ng-click=\"searchPharmacies()\">\r" +
    "\n" +
    "                        {{'Search Pharmacy' |translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <!--<div class=\"panel panel-results\">-->\r" +
    "\n" +
    "            <div ng-show=\"noResults\">{{::'No Results Found' | translate}}</div>\r" +
    "\n" +
    "                <div ng-repeat=\"pharmacy in pharmacyResults\" ng-if=\"pharmacy\">\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-2\">\r" +
    "\n" +
    "                            {{pharmacy.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-md-3\">\r" +
    "\n" +
    "                            <div>{{pharmacy.Address.Address1}}</div>\r" +
    "\n" +
    "                            <div>{{pharmacy.Address.Address2}}</div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-2 col-md-1\">\r" +
    "\n" +
    "                            {{pharmacy.Address.State}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-3 col-md-2\">\r" +
    "\n" +
    "                            {{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-4 col-md-2\">\r" +
    "\n" +
    "                            {{pharmacy.Phone.PhoneNumber}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-3 col-md-2\" ng-click=\"addPharmacy($index, pharmacy)\">\r" +
    "\n" +
    "                            <i class=\"fa fa-plus-circle\"></i>&nbsp;{{::'Add' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"modal-footer\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <button class=\"btn btn-primary text-center btn-lg\" id=\"ok-btn\" ng-click=\"ok()\">{{::'OK' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-6\">\r" +
    "\n" +
    "                <button class=\"btn btn-default2 text-center btn-lg\" id=\"cancel-btn\" ng-click=\"cancel()\">{{::'Cancel' | translate}}</button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/myChart.html',
    "<div class=\"container-fluid container-flush\" ng-cloak>\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "        <div class=\"panel panel-primary panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-header ap-mychart-border hidden-print\">\r" +
    "\n" +
    "                <img class=\"rounded-corner-md border-width-md extra-dark-grey-border list-item-thumbnail ap-mychart-align-left\"\r" +
    "\n" +
    "                    lazy-src=\"{{myChart.User.Id | apPatientPortalThumbnailSrc:83:82}}\" endpoint-base='patient' alt=\"patient-image\">\r" +
    "\n" +
    "                <div class=\"panel-title ap-mychart-title\">\r" +
    "\n" +
    "                    <div class=\"font-patient-name\">{{::myChart.User.FullName}}</div>\r" +
    "\n" +
    "                    <div ng-if=\"Date\">\r" +
    "\n" +
    "                        <ap-date-formatter date=\"Date\" format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                        <span>({{myChart.User.Age}})</span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"panel-body col-xs-12\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-sm-3 col-md-3 col-lg-2 col-flush-left\" ng-if=\"ShowSidebar\">\r" +
    "\n" +
    "                        <div class=\"ap-mychart-nav ap-mychart-align-left hidden-print\">\r" +
    "\n" +
    "                            <div ng-click=\"expandMedicalDetails()\">\r" +
    "\n" +
    "                                <div ng-class=\"(!collapseMedicalHistory)?'ap-mychart-nav-focus':''\">\r" +
    "\n" +
    "                                    <label>{{::'Medical History' | translate}}</label>\r" +
    "\n" +
    "                                    <i ng-show=\"collapseMedicalHistory\" class=\"pull-right fa fa-caret-down\"></i>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <uib-tabset class=\"list-unstyled\" vertical=\"true\" uib-collapse=\"collapseMedicalHistory\">\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewClinicalSummary.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewClinicalSummary.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewClinicalSummary.Id\">\r" +
    "\n" +
    "                                        {{:: 'Visit Summaries' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewDocuments.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewDocuments.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewDocuments.Id\">\r" +
    "\n" +
    "                                        {{:: 'Documents' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewProblems.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewProblems.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewProblems.Id\">\r" +
    "\n" +
    "                                        {{:: 'Problems' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewMedications.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewMedications.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewMedications.Id\">\r" +
    "\n" +
    "                                        {{:: 'Medications' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewProcedures.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewProcedures.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewProcedures.Id\">\r" +
    "\n" +
    "                                        {{:: 'Procedures' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewLabResults.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewLabResults.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewLabResults.Id\">\r" +
    "\n" +
    "                                        {{:: 'Test Results' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewImmunizations.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewImmunizations.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewImmunizations.Id\">\r" +
    "\n" +
    "                                        {{:: 'Immunizations' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewEducationMaterial.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewEducationMaterial.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewEducationMaterial.Id\">\r" +
    "\n" +
    "                                        {{:: 'Educational Material' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                                <uib-tab ng-show=\"myChart.Config.ViewMedicationAllergies.IsActive\"\r" +
    "\n" +
    "                                     data-transition-to=\"{appRoute: myChart.Config.ViewMedicationAllergies.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                    <uib-tab-heading id=\"myChart.Config.ViewMedicationAllergies.Id\">\r" +
    "\n" +
    "                                        {{:: 'Medication Allergies' | translate }}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                            </uib-tabset>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"ap-mychart-nav-divider\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-click=\"expandPersonalDetails()\"\r" +
    "\n" +
    "                                 data-transition-to=\"{appRoute: myChart.Config.UpdateDemographics.Route, opts : {id: myChart.User.Id}}\">\r" +
    "\n" +
    "                                <div ng-class=\"(!collapsePersonalDetails)?'ap-mychart-nav-focus':''\">\r" +
    "\n" +
    "                                    <label\r" +
    "\n" +
    "                                           id=\"myChart.Config.UpdateDemographics.Id\">\r" +
    "\n" +
    "                                        {{::'Personal Details' | translate}}</label>\r" +
    "\n" +
    "                                    <i ng-show=\"collapsePersonalDetails\" class=\"pull-right fa fa-caret-down\"></i>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <uib-tabset verical=\"true\" uib-collapse=\"collapsePersonalDetails\">\r" +
    "\n" +
    "                                <uib-tab>\r" +
    "\n" +
    "                                    <uib-tab-heading>\r" +
    "\n" +
    "                                        {{::'Patient Overview' | translate}}\r" +
    "\n" +
    "                                    </uib-tab-heading>\r" +
    "\n" +
    "                                </uib-tab>\r" +
    "\n" +
    "                            </uib-tabset>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"ap-mychart-nav-divider\"></div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div class=\"ap-mychart-nav-focus\">\r" +
    "\n" +
    "                                <label>{{::'Actions' | translate}}</label>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <button ng-show=\"myChart.Config.AllowGenerateCCD.IsActive\" class=\"btn btn-default2 btn-overflow\" id=\"myChart_CCDBtn\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'shareCCD'}\">\r" +
    "\n" +
    "                                {{::'Continuity Care Document' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <button ng-show=\"myChart.Config.ViewCompleteChart.IsActive\" class=\"btn btn-default2 btn-overflow\" id=\"myChart_DownloadChartBtn\" ng-click=\"viewCompleteChartImage()\">\r" +
    "\n" +
    "                                {{::'View Complete Chart' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-class=\"(ShowSidebar)?'col-xs-8 col-sm-9 col-md-9 col-lg-10 col-flush-right':'col-xs-12 col-flush'\">\r" +
    "\n" +
    "                        <div class=\"container-fluid container-flush\" ui-view></div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and My Chart could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to My Chart.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/myChartMobile.html',
    "<div class=\"container-fluid container-flush hidden-print\" ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-mobile panel-flush\" ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "        <div class=\"panel-header\">\r" +
    "\n" +
    "            <div class=\"panel-title text-uppercase text-center-vert\">\r" +
    "\n" +
    "                <img class=\"toolbar-svg chart\" src=\"images/spacer.png\">\r" +
    "\n" +
    "                <span class=\"title-text\">{{::\"Chart\" | translate }}</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-header patient-header\">\r" +
    "\n" +
    "            <img class=\"rounded-corner-md border-width-md extra-dark-grey-border list-item-thumbnail\"\r" +
    "\n" +
    "                 lazy-src=\"{{myChart.User.Id | apPatientPortalThumbnailSrc:83:82}}\" endpoint-base='patient' alt=\"patient-image\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-patient\">\r" +
    "\n" +
    "                <h2>{{::myChart.User.FullName}}</h2>\r" +
    "\n" +
    "                <ap-date-formatter date=\"{{::Date}}\" format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                <span>({{myChart.User.Age}})</span>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-body col-xs-12 col-xs-flush\" ng-if=\"ShowSidebar\">\r" +
    "\n" +
    "            <div id=\"mychart\" class=\"container-fluid container-flush\" ng-cloak>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewClinicalSummary.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/visitSummary.html'\"\r" +
    "\n" +
    "                     ng-controller=\"VisitSummaryCtrl\"\r" +
    "\n" +
    "                     ng-init=\"tileState.isCollapsed = !openPersonalDetails\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewProblems.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/problems.html'\"\r" +
    "\n" +
    "                     ng-controller=\"ProblemsMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewMedications.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/prescriptionsList.html'\"\r" +
    "\n" +
    "                     ng-controller=\"RxRefillMobileChartCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewProcedures.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/procedures.html'\"\r" +
    "\n" +
    "                     ng-controller=\"ProceduresMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewLabResults.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/labResults.html'\"\r" +
    "\n" +
    "                     ng-controller=\"LabResultsMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewImmunizations.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/immunizations.html'\"\r" +
    "\n" +
    "                     ng-controller=\"ImmunizationsMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewEducationMaterial.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/referenceMaterial.html'\"\r" +
    "\n" +
    "                     ng-controller=\"ReferenceMaterialMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-show=\"myChart.Config.ViewMedicationAllergies.IsActive\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/medicationAllergies.html'\"\r" +
    "\n" +
    "                     ng-controller=\"MedicationAllergiesMobileCtrl\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\"\r" +
    "\n" +
    "                     ng-include=\"'/mychart/views/mobile/personalDetails.html'\"\r" +
    "\n" +
    "                     ng-controller=\"PersonalDetailsMobileCtrl\"\r" +
    "\n" +
    "                     ng-init=\"openPersonalDetails && toggleState()\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"tile\">\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                            <button class=\"btn btn-lg btn-default btn-block\" id=\"myChart_CCDBtn\"\r" +
    "\n" +
    "                            data-transition-to=\"{appRoute: 'shareCCD'}\">\r" +
    "\n" +
    "                            {{::'Continuity Care Document' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                            <button class=\"btn btn-lg btn-default btn-block\" id=\"myChart_DownloadChartBtn\"\r" +
    "\n" +
    "                                    ng-click=\"displayCompleteChart()\">\r" +
    "\n" +
    "                                <i class=\"fa fa-download\"></i> {{::'Download Chart' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"panel-body col-xs-12\" ng-if=\"!ShowSidebar\" ui-view>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and My Chart could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to My Chart.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/patientDocuments.html',
    "<ap-patient-documents></ap-patient-documents>"
  );


  $templateCache.put('/mychart/views/personalDetails.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <form name=\"editPatientDetailsForm\" ng-submit=\"saveUpdateDetailsRequest(editPatientDetailsForm)\" novalidate>\r" +
    "\n" +
    "        <div class=\"panel panel-demo chart-label\">\r" +
    "\n" +
    "            <div class=\"panel-heading panel-flush\">\r" +
    "\n" +
    "                <div class=\"panel-title\">\r" +
    "\n" +
    "                    {{::'Patient Overview' | translate}}\r" +
    "\n" +
    "                    <span class=\"pull-right\">\r" +
    "\n" +
    "                        <button id=\"save-details-btn\" class=\"btn btn-default2\" ng-if=\"edit\" type=\"submit\" ng-disabled=\"saving || !editPatientDetailsForm.$dirty\">\r" +
    "\n" +
    "                            {{::'Save' | translate}}\r" +
    "\n" +
    "                            <span ng-if=\"saving\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <button type=button id=\"edit-details-btn\" class=\"btn btn-default2\" ng-show=\"config.UpdateDemographics.IsActive\" ng-if=\"!edit\" ng-click=\"editDetails()\">\r" +
    "\n" +
    "                            {{::'Edit' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <button type=button id=\"cancel-details-btn\" class=\"btn btn-default2\" ng-if=\"edit\" ng-click=\"cancelEdit()\">\r" +
    "\n" +
    "                            {{::'Cancel' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-include=\"'/mychart/views/personalDetailsCommon.html'\" />\r" +
    "\n" +
    "            <div ng-if=\"false\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    {{::'Medication Allergies' | translate}}\r" +
    "\n" +
    "                    <span class=\"pull-right\"><label class=\"control-label\">{{::'Edit' | translate}}</label></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"false\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    {{::'Family Medication History' | translate}}<span class=\"pull-right\"><label class=\"control-label\">{{::'Edit' | translate}}</label></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"false\">\r" +
    "\n" +
    "                <div class=\"panel-heading\">\r" +
    "\n" +
    "                    {{::'Social History' | translate}}\r" +
    "\n" +
    "                    <span class=\"pull-right\"><label class=\"control-label\">{{::'Edit' | translate}}</label></span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/personalDetailsCommon.html',
    "            <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-md-6 col-xs-flush-left\">\r" +
    "\n" +
    "                        <div class=\"panel-subheading\">\r" +
    "\n" +
    "                            {{::'Personal Details' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"row\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-class=\"(edit)? 'col-xs-12 col-md-12 col-xs-flush' : 'col-xs-12 col-md-6 col-xs-flush-left'\">\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'SSN' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        {{patientDetail.SocialSecurityNumber | apSsnFilter}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.SocialSecurityNumber\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'SSN' | translate}}</label>\r" +
    "\n" +
    "                                    <input class=\"form-control\" id=\"socialSecurityNumber\" name=\"socialSecurityNumber\" ng-model=\"updateDetailsRequestDto.SocialSecurityNumber\"\r" +
    "\n" +
    "                                    type=\"text\" placeholder=\"XXX-XX-XXXX\"  ng-pattern=\"ssnRegEx\" ap-ssn-field ap-required>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Phone No.' | translate}}</label>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <div class=\"row\" ng-if=\"patientDetail.PhoneNumber1\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-12 col-flush\">\r" +
    "\n" +
    "                                            <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                {{patientDetail.PhoneNumber1Type.Description}}: {{patientDetail.PhoneNumber1 | tel}}\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\" ng-if=\"!hasPhoneNumber\">\r" +
    "\n" +
    "                                        {{::'None' | translate}}\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-6 col-flush-left\">\r" +
    "\n" +
    "                                                <select class=\"form-control arrow-dropdown\" name=\"phoneNumber1Type\" ng-model=\"updateDetailsRequestDto.PhoneNumber1Type\" ng-options=\"phoneType.Description for phoneType in phoneTypes\"\r" +
    "\n" +
    "                                                ap-metadata>\r" +
    "\n" +
    "                                                </select>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-6 col-flush\">\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <input class=\"form-control\" id=\"phoneNumber1\" name=\"phoneNumber1\" ng-model=\"updateDetailsRequestDto.PhoneNumber1\" type=\"text\"\r" +
    "\n" +
    "                                                placeholder=\"(XXX)XXX-XXXX\" ng-pattern=\"phoneRegEx\" ap-required>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"edit\" class=\"btn-spacing\">\r" +
    "\n" +
    "                                <button type=button id=\"show-phonedetails-btn\" class=\"btn btn-default2\" ng-click=\"addNumbers()\">\r" +
    "\n" +
    "                                    {{::' Additional Phone Numbers' | translate}}\r" +
    "\n" +
    "                                </button>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <div ng-if=\"plusPhone && edit\">\r" +
    "\n" +
    "                                <div class=\"additionalPhoneNum\">\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"!edit && patientDetail.PhoneNumber2\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-md-12 col-flush\">\r" +
    "\n" +
    "                                            <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                {{patientDetail.PhoneNumber2Type.Description}}: {{patientDetail.PhoneNumber2 | tel}}\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                                <select class=\"form-control arrow-dropdown\" name=\"phoneNumber2Type\" ng-model=\"updateDetailsRequestDto.PhoneNumber2Type\" ng-options=\"phoneType.Description for phoneType in phoneTypes\"\r" +
    "\n" +
    "                                                ap-metadata>\r" +
    "\n" +
    "                                                </select>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush\">\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <input class=\"form-control\" id=\"phoneNumber2\" name=\"phoneNumber2\" ng-model=\"updateDetailsRequestDto.PhoneNumber2\" type=\"text\"\r" +
    "\n" +
    "                                                placeholder=\"(XXX)XXX-XXXX\" ng-pattern=\"phoneRegEx\" ap-required>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit && patientDetail.PhoneNumber3\" class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-12 col-flush\">\r" +
    "\n" +
    "                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                            {{patientDetail.PhoneNumber3Type.Description}}: {{patientDetail.PhoneNumber3 | tel}}\r" +
    "\n" +
    "                                        </p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                    <br/>\r" +
    "\n" +
    "                                <div ng-if=\"edit\" class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                                <select class=\"form-control arrow-dropdown\" name=\"phoneNumber3Type\" ng-model=\"updateDetailsRequestDto.PhoneNumber3Type\" ng-options=\"phoneType.Description for phoneType in phoneTypes\"\r" +
    "\n" +
    "                                                ap-metadata>\r" +
    "\n" +
    "                                                </select>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush\">\r" +
    "\n" +
    "                                            <input class=\"form-control\" id=\"phoneNumber3\" name=\"phoneNumber3\" ng-model=\"updateDetailsRequestDto.PhoneNumber3\" type=\"text\"\r" +
    "\n" +
    "                                            placeholder=\"(XXX)XXX-XXXX\" ng-pattern=\"phoneRegEx\" ap-required>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"!edit && patientDetail.PhoneNumber4\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-2 col-flush\">\r" +
    "\n" +
    "                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                            {{patientDetail.PhoneNumber4Type.Description}}\r" +
    "\n" +
    "                                        </p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-1 col-flush\">\r" +
    "\n" +
    "                                        <p class=\"form-control-static\">:</p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-9 col-flush\">\r" +
    "\n" +
    "                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                            {{patientDetail.PhoneNumber4 | tel}}\r" +
    "\n" +
    "                                        </p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                    <br/>\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                                <select class=\"form-control arrow-dropdown\" name=\"phoneNumber4Type\" ng-model=\"updateDetailsRequestDto.PhoneNumber4Type\" ng-options=\"phoneType.Description for phoneType in phoneTypes\"\r" +
    "\n" +
    "                                                ap-metadata>\r" +
    "\n" +
    "                                                </select>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-flush\">\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <input class=\"form-control\" id=\"phoneNumber4\" name=\"phoneNumber4\" ng-model=\"updateDetailsRequestDto.PhoneNumber4\" type=\"text\"\r" +
    "\n" +
    "                                                placeholder=\"(XXX)XXX-XXXX\" ng-pattern=\"phoneRegEx\" ap-required>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                <label class=\"control-label\">{{::'Email' | translate}}</label>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <span ng-if=\"!hasEmailAddress\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    <p class=\"label_wrap\">{{patientDetail.EmailAddress1}}</p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <input class=\"form-control label_wrap\" id=\"emailAddress1\" name=\"EmailAddress1\" ng-model=\"updateDetailsRequestDto.EmailAddress1\" type=\"text\"\r" +
    "\n" +
    "                                    placeholder=\"Email Address 1\" ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\" ng-if=\"patientDetail.EmailAddress2\">\r" +
    "\n" +
    "                                    <p class=\"label_wrap\">{{patientDetail.EmailAddress2}}</p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <input class=\"form-control label_wrap\" id=\"emailAddress2\" name=\"EmailAddress2\" ng-model=\"updateDetailsRequestDto.EmailAddress2\" type=\"text\"\r" +
    "\n" +
    "                                    placeholder=\"Email Address 2\" ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Address' | translate}}</label>\r" +
    "\n" +
    "                                    <div>\r" +
    "\n" +
    "                                        {{patientDetail.Address1.Address1}},\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"patientDetail.Address1.Address2 && !edit\">\r" +
    "\n" +
    "                                        {{patientDetail.Address1.Address2}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                        {{patientDetail.Address1.City}}, {{patientDetail.Address1.State}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"patientDetail.Address1.Country && !edit\">\r" +
    "\n" +
    "                                        {{patientDetail.Address1.Country}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"patientDetail.Address1.Zip && !edit\">\r" +
    "\n" +
    "                                        {{patientDetail.Address1.Zip}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Address' | translate}}</label>\r" +
    "\n" +
    "                                    <input class=\"form-control\" id=\"addressLine1\" name=\"Address1\" ng-model=\"updateDetailsRequestDto.Address1.Address1\" type=\"text\"\r" +
    "\n" +
    "                                    placeholder=\"Address Line 1\" ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <input class=\"form-control\" id=\"addressLine2\" name=\"Address2\" ng-model=\"updateDetailsRequestDto.Address1.Address2\" type=\"text\"\r" +
    "\n" +
    "                                    placeholder=\"Address Line 2\" ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush-left\">\r" +
    "\n" +
    "                                        <div class=\"form-group\">\r" +
    "\n" +
    "                                            <input class=\"form-control\" id=\"addressCity\" name=\"City\" ng-model=\"updateDetailsRequestDto.Address1.City\" type=\"text\" placeholder=\"City\"\r" +
    "\n" +
    "                                            ap-metadata>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush\">\r" +
    "\n" +
    "                                        <div class=\"form-group\">\r" +
    "\n" +
    "                                            <input class=\"form-control\" id=\"addressState\" name=\"State\" maxlength=\"2\" ng-pattern=\"/^[a-zA-Z]*$/\" ng-model=\"updateDetailsRequestDto.Address1.State\"\r" +
    "\n" +
    "                                            type=\"text\" placeholder=\"State e.g: TX,CA,MN\" ap-metadata>\r" +
    "\n" +
    "                                            <p ng-show=\"editPatientDetailsForm.State.$error.pattern\" class=\"help-block\">No special characters</p>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <input class=\"form-control\" id=\"addressZip\" name=\"Zip\" ng-model=\"updateDetailsRequestDto.Address1.Zip\" type=\"text\" placeholder=\"Zip Code\"\r" +
    "\n" +
    "                                    ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <input class=\"form-control\" id=\"addressCountry\" name=\"Country\" ng-model=\"updateDetailsRequestDto.Address1.Country\" type=\"text\"\r" +
    "\n" +
    "                                    placeholder=\"Country\" ap-metadata>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <span ng-if=\"!patientDetail.Address1.Address1\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-class=\"(edit)? 'col-xs-12 col-md-12 col-xs-flush' : 'col-xs-12 col-md-6 col-xs-flush'\">\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Gender' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        {{patientDetail.Gender.Name}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Gender.Name\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Gender' | translate}}</label>\r" +
    "\n" +
    "                                        <select class=\"form-control arrow-dropdown\" name=\"GenderType\" ng-model=\"updateDetailsRequestDto.Gender\" ng-options=\"genderType.Name for genderType in genderTypes\"\r" +
    "\n" +
    "                                        ap-metadata>\r" +
    "\n" +
    "                                        </select>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Marital Status' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        {{patientDetail.MaritalStatus.Description}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.MaritalStatus.Description\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Marital Status' | translate}}</label>\r" +
    "\n" +
    "                                        <select class=\"form-control arrow-dropdown\" name=\"MaritalStatusType\" ng-model=\"updateDetailsRequestDto.MaritalStatus\" ng-options=\"maritalStatusType.Description for maritalStatusType in maritalStatusTypes | orderBy:'Description' \"\r" +
    "\n" +
    "                                        ap-metadata>\r" +
    "\n" +
    "                                        </select>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Race' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        {{patientDetail.Race.Description}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Race.Description\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Race' | translate}}</label>\r" +
    "\n" +
    "                                        <select class=\"form-control arrow-dropdown\" name=\"RaceType\" ng-model=\"updateDetailsRequestDto.Race\" ng-options=\"raceType.Description for raceType in raceTypes | orderBy:'Description'\"\r" +
    "\n" +
    "                                        ap-metadata>\r" +
    "\n" +
    "                                        </select>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Ethnicity' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        <span ng-repeat=\"ethnicity in patientDetail.Ethnicity\">\r" +
    "\n" +
    "                                            {{::ethnicity.Description}}<span ng-if=\"$index+1 < patientDetail.Ethnicity.length\">,</span>\r" +
    "\n" +
    "                                        </span>\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Ethnicity.length\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Ethnicity' | translate}}</label>\r" +
    "\n" +
    "                                    <ap-multi-select-list-item\r" +
    "\n" +
    "                                        class=\"btn-multi-select\"\r" +
    "\n" +
    "                                        id=\"ethnicitySelect\"\r" +
    "\n" +
    "                                        collection=\"ethnicityTypes\"\r" +
    "\n" +
    "                                        ng-model=\"updateDetailsRequestDto.Ethnicity\"\r" +
    "\n" +
    "                                        ap-metadata>\r" +
    "\n" +
    "                                    </ap-multi-select-list-item>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Language' | translate}}</label>\r" +
    "\n" +
    "                                    <p class=\"form-control-static\">\r" +
    "\n" +
    "                                        {{patientDetail.Language.Description}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Language.Description\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                    <label class=\"control-label\">{{::'Language' | translate}}</label>\r" +
    "\n" +
    "                                        <select class=\"form-control arrow-dropdown\" name=\"LanguageType\" ng-model=\"updateDetailsRequestDto.Language\" ng-options=\"languageType.Description for languageType in languageTypes | orderBy:'Description'\"\r" +
    "\n" +
    "                                        ap-metadata>\r" +
    "\n" +
    "                                        </select>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                                {{::'Driver\\'s License'| translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                    <p class=\"form-control-static\" ng-if=\"!edit\">\r" +
    "\n" +
    "                                        {{patientDetail.DriversLicenseNumber}}\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.DriversLicenseNumber\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </p>\r" +
    "\n" +
    "                                    <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                        <input class=\"form-control\"  id=\"driversLicenseNumber\" name=\"DriversLicenseNumber\" ng-model=\"updateDetailsRequestDto.DriversLicenseNumber\"\r" +
    "\n" +
    "                                        type=\"text\" placeholder=\"Drivers License Number\" ap-metadata>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <label class=\"control-label\" ng-if=\"!edit\" ng-if=\"patientDetail.DriversLicenseState\">\r" +
    "\n" +
    "                                        {{patientDetail.DriversLicenseState}}\r" +
    "\n" +
    "                                    </label>\r" +
    "\n" +
    "                                    <div class=\"form-group\" ng-if=\"edit\">\r" +
    "\n" +
    "                                        <input class=\"form-control\" id=\"driversLicenseState\" name=\"DriversLicenseState\" maxlength=\"2\" ng-pattern=\"/^[a-zA-Z]*$/\" ng-model=\"updateDetailsRequestDto.DriversLicenseState\"\r" +
    "\n" +
    "                                        type=\"text\" placeholder=\"Drivers License State e.g: TX,CA,MN\" required ap-metadata>\r" +
    "\n" +
    "                                        <p ng-show=\"editPatientDetailsForm.DriversLicenseState.$error.pattern\" class=\"help-block\">No special characters</p>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-md-6 col-xs-flush\">\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                                {{::'Emergency Contact' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"form-group\">\r" +
    "\n" +
    "                                        <div ng-repeat=\"contact in patientDetail.Contacts\">\r" +
    "\n" +
    "                                            <span>{{::contact.FirstName}}&nbsp;{{::contact.LastName}}</span>\r" +
    "\n" +
    "                                            <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                {{::contact.PhoneNumber1.PhoneNumber}}\r" +
    "\n" +
    "                                                <span ng-if=\"!contact.PhoneNumber1.PhoneNumber\">{{::'Unknown' | translate}}</span>\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                            <label class=\"control-label\">{{::'Primary No.' | translate}}</label>\r" +
    "\n" +
    "                                            <p class=\"form-control-static\" ng-if=\"contact.PhoneNumber2.PhoneNumber\">\r" +
    "\n" +
    "                                                {{::contact.PhoneNumber2.PhoneNumber}}\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                            <label class=\"control-label\">{{::'Secondary No.' | translate}}</label>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Contacts\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                                {{::'Pharmacies' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-if=\"!edit\">\r" +
    "\n" +
    "                                <div ng-repeat=\"pharmacy in patientDetail.Pharmacies track by $index\">\r" +
    "\n" +
    "                                    <div ng-if=\"$index==0\" class=\"row\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-sm-6 col-flush-left\">\r" +
    "\n" +
    "                                            <div class=\"personal-details-map\">\r" +
    "\n" +
    "                                                <ap-google-maps name=\"pharmacy.Name\" address=\"pharmacy.Address.Address1\" city=\"pharmacy.Address.City\" state=\"pharmacy.Address.State\"\r" +
    "\n" +
    "                                                zip=\"pharmacy.Address.Zip\" height=\"135\" width=\"200\">\r" +
    "\n" +
    "                                                </ap-google-maps>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <div class=\"col-xs-12 col-sm-6 col-flush\">\r" +
    "\n" +
    "                                            <label class=\"control-label\">{{::'Preferred Pharmacy' | translate}}</label>\r" +
    "\n" +
    "                                            <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                {{pharmacy.Name}}\r" +
    "\n" +
    "                                                <span ng-if=\"!pharmacy.Name\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                            <div class=\"form-control-static\">\r" +
    "\n" +
    "                                                <div>{{pharmacy.Address.Address1}}</div>\r" +
    "\n" +
    "                                                <div ng-if=\"pharmacy.Address.Address2\">\r" +
    "\n" +
    "                                                    {{pharmacy.Address.Address2}},&nbsp;{{pharmacy.Address.State}}&nbsp;{{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div ng-if=\"!pharmacy.Address.Address2\">\r" +
    "\n" +
    "                                                    {{pharmacy.Address.State}}&nbsp;{{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div>{{::'p.' | translate}}&nbsp;{{pharmacy.Phone.PhoneNumber | tel}}<span ng-if=\"!pharmacy.Phone.PhoneNumber\">{{::'None' | translate}}</span></div>\r" +
    "\n" +
    "                                                <span ng-if=\"!pharmacy.Address.Address1\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                        <span ng-if=\"!patientDetail.Pharmacies\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div ng-if=\"$index!=0\">\r" +
    "\n" +
    "                                        <div class=\"row\">\r" +
    "\n" +
    "                                            <div class=\"col-xs-12 col-sm-4 col-flush-left\">\r" +
    "\n" +
    "                                                <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                    {{pharmacy.Name}}\r" +
    "\n" +
    "                                                    <span ng-if=\"!pharmacy.Name\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                                </p>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"col-xs-12 col-sm-4 col-flush-left\">\r" +
    "\n" +
    "                                                <div class=\"form-control-static\">\r" +
    "\n" +
    "                                                    <div>{{pharmacy.Address.Address1}}</div>\r" +
    "\n" +
    "                                                    <div ng-if=\"pharmacy.Address.Address2\">\r" +
    "\n" +
    "                                                        {{pharmacy.Address.Address2}},&nbsp;{{pharmacy.Address.State}}&nbsp;{{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <span ng-if=\"!pharmacy.Address.Address1\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div class=\"col-xs-12 col-sm-4 col-flush-right\">\r" +
    "\n" +
    "                                                <div class=\"form-control-static\"><div class=\"pharmacies\">\r" +
    "\n" +
    "                                                    {{::'p.' | translate}}&nbsp;{{pharmacy.Phone.PhoneNumber | tel}}\r" +
    "\n" +
    "                                                    <span ng-if=\"!pharmacy.Phone.PhoneNumber\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <span ng-if=\"!patientDetail.Pharmacies\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div ng-if=\"edit\">\r" +
    "\n" +
    "                                <div class=\"row\" id=\"currentPharmaciesList\" ng-repeat=\"pharmacy in updateDetailsRequestDto.Pharmacies track by $index\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush-left\">\r" +
    "\n" +
    "                                       <strong>{{pharmacy.Name}}</strong>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush\" ng-click=\"removePharmacy($index, pharmacy)\">\r" +
    "\n" +
    "                                        <i class=\"fa fa-minus-circle\"></i>&nbsp;&nbsp;{{::'Remove' | translate}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush\">\r" +
    "\n" +
    "                                        <div>{{pharmacy.Address.Address1}}</div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-6 col-flush-left\" ng-if=\"pharmacy.Address.Address2\">\r" +
    "\n" +
    "                                        <div>{{pharmacy.Address.Address2}}</div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-12 col-flush\">\r" +
    "\n" +
    "                                        <div>{{pharmacy.Address.State}} , {{pharmacy.Address.Zip}}\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-md-12 col-flush\">\r" +
    "\n" +
    "                                        <div>{{pharmacy.Phone.PhoneNumber | tel}}</div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"btn-spacing\">\r" +
    "\n" +
    "                                    <button type=button id=\"add-pharmacies-btn\" class=\"btn btn-default2\" ng-click=\"open()\">{{'Add/Search Pharmacies' | translate}}\r" +
    "\n" +
    "                                    </button>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div>\r" +
    "\n" +
    "                                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                                    {{::'Insurance Details' | translate}}\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"row\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                        <div>\r" +
    "\n" +
    "                                            <p class=\"form-control-static\"><strong>\r" +
    "\n" +
    "                                                {{patientDetail.Insurance.InsuranceCarrier.Name}} {{patientDetail.Insurance.InsurancePlan.Name}}</strong>\r" +
    "\n" +
    "                                                <span ng-if=\"!patientDetail.Insurance.InsuranceCarrier.Name\">{{::'None' | translate}}</span>\r" +
    "\n" +
    "                                            </p>\r" +
    "\n" +
    "                                            <div ng-if=\"patientDetail.Insurance.InsuranceCarrier.Name\">\r" +
    "\n" +
    "                                                <div class=\"row\">\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                                                        <label class=\"control-label\">{{::'Primary' | translate}}</label>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-8 col-flush\">\r" +
    "\n" +
    "                                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                            {{patientDetail.Insurance.PrimaryAccountHolderFirstName}}&nbsp;{{patientDetail.Insurance.PrimaryAccountHolderLastName}}\r" +
    "\n" +
    "                                                        </p>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div class=\"row\">\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                                                        <label class=\"control-label\">{{::'Member Id.' | translate}}</label>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-8 col-flush\">\r" +
    "\n" +
    "                                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                            {{patientDetail.Insurance.PlanMemberId}}\r" +
    "\n" +
    "                                                        </p>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div class=\"row\">\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-4 col-flush\">\r" +
    "\n" +
    "                                                        <label class=\"control-label\">{{::'Group Id.' | translate}}</label>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                    <div class=\"col-xs-12 col-md-8 col-flush\">\r" +
    "\n" +
    "                                                        <p class=\"form-control-static\">\r" +
    "\n" +
    "                                                            {{patientDetail.Insurance.PlanGroupId}}\r" +
    "\n" +
    "                                                        </p>\r" +
    "\n" +
    "                                                    </div>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>"
  );


  $templateCache.put('/mychart/views/prescriptionsList.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-default panel-flush table-responsive\" id=\"presriptions-panel\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Prescriptions' | translate}}\r" +
    "\n" +
    "            <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "                <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" id=\"recent-filter-btn\"\r" +
    "\n" +
    "                            uib-dropdown-toggle>\r" +
    "\n" +
    "                        <span>{{::'View' | translate }}&nbsp;&nbsp;</span>\r" +
    "\n" +
    "                        <span class=\"title-text\">{{ activeFilter.Name | translate }}</span>\r" +
    "\n" +
    "                        <span class=\"caret\"></span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"medFilter\">\r" +
    "\n" +
    "                        <li class=\"clickable\" role=\"presentation\" ng-repeat=\"medFilter in medFilters\">\r" +
    "\n" +
    "                            <a id=\"day-filter-item-{{medFilter.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                               ng-click=\"updateFilteredPrescriptions(medFilter)\">{{ ::medFilter.Name | translate }}</a>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body table-responsive\">\r" +
    "\n" +
    "            <div ng-if=\"!filteredPrescriptions.length\">\r" +
    "\n" +
    "                {{::'No prescriptions were found' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <table id=\"prescriptions-table\" class=\"table table-striped\" ng-if=\"filteredPrescriptions.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                <tr>\r" +
    "\n" +
    "                    <th>{{::'Drug + Directions' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Status' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Duration' | translate}}</th>\r" +
    "\n" +
    "                    <th ng-if=\"featureList.RequestRxRefills.IsActive\">{{::'Request Refill' | translate}}</th>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "                <tbody>\r" +
    "\n" +
    "                <tr ng-repeat=\"med in filteredPrescriptions\">\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"column-text\">\r" +
    "\n" +
    "                            {{::med.DrugName}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"column-subtext\">\r" +
    "\n" +
    "                            {{::med.Instructions}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        {{::med.IsActive ? dateDiff(med.EndDate) : ''}}\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"column-text\">\r" +
    "\n" +
    "                            <label>{{::'Start' | translate}}&nbsp;</label>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{::med.StartDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"column-text\">\r" +
    "\n" +
    "                            <label>{{::'End' | translate}}&nbsp;</label>\r" +
    "\n" +
    "                            <span ap-date-formatter date=\"{{::med.EndDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td ng-if=\"featureList.RequestRxRefills.IsActive\">\r" +
    "\n" +
    "                        <div class=\"pull-right\" ng-if=\"!med.RefillRequestPending && !med.IsDiscontinued && med.ProviderId\">\r" +
    "\n" +
    "                            <button class=\"btn btn-lg-height btn-default1\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'rxrefill'}\">{{::'Request Refill' | translate}}\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"pull-right\" ng-if=\"med.IsDiscontinued\">\r" +
    "\n" +
    "                            <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                    class=\"btn-width pending text-center\">{{'Discontinued' | translate}}</span></div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"pull-right\" ng-if=\"med.RefillRequestPending\">\r" +
    "\n" +
    "                            <button class=\"btn btn-lg-height btn-default1 btn-minpadding\" ng-click=\"medSelect(med)\"\r" +
    "\n" +
    "                                    data-transition-to=\"{appRoute: 'rxrefill'}\"><span class=\"lime-green\">{{'Refill Requested' | translate}}</span>\r" +
    "\n" +
    "                            </button>\r" +
    "\n" +
    "                            <div class=\"pending text-center\">{{'Pending Review' | translate}}</div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"pull-right\" ng-if=\"!med.ProviderId\">\r" +
    "\n" +
    "                            <div class=\"btn-height flexbox flexbox-horizontal-center\"><span\r" +
    "\n" +
    "                                    class=\"btn-width pending text-center\">{{'Please contact office to process.' | translate}}</span></div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </tbody>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient medications could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s medications.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/problems.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-default panel-flush table-responsive\" id=\"problems-panel\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Problems' | translate}}\r" +
    "\n" +
    "        <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "            <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                <button class=\"btn btn-default\" type=\"button\" id=\"active-filter-btn\"\r" +
    "\n" +
    "                        uib-dropdown-toggle>\r" +
    "\n" +
    "                    <span>{{::'View' | translate }}&nbsp;&nbsp;</span>\r" +
    "\n" +
    "                    <span class=\"title-text\">{{ problem.activeName | translate }}</span>\r" +
    "\n" +
    "                    <span class=\"caret\"></span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" id=\"activeFilter\">\r" +
    "\n" +
    "                    <li class=\"clickable\" role=\"presentation\" ng-repeat=\"activeFilter in activeFilters\">\r" +
    "\n" +
    "                        <a id=\"active-filter-item-{{activeFilter.Id}}\" role=\"menuitem\"\r" +
    "\n" +
    "                           ng-click=\"update(activeFilter.Id)\">{{ ::activeFilter.Name | translate }}</a>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"table-responsive\">\r" +
    "\n" +
    "            <div ng-if=\"!filteredProblems.length\">\r" +
    "\n" +
    "                {{::'No problems were found' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <table id=\"problems-table\" class=\"table ap-problems-table\" ng-if=\"filteredProblems.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                <tr>\r" +
    "\n" +
    "                    <th>{{::'Disease' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Date' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Status' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Duration' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Notes' | translate}}</th>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "                <tbody>\r" +
    "\n" +
    "                <tr ng-class=\"{'clickable' : prob.Notes}\" ng-click=\"hidden(prob)\"\r" +
    "\n" +
    "                    ng-repeat-start=\"prob in filteredProblems\">\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        {{prob.Name}}\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{prob.Date}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        {{prob.IsActive ? ('Active' | translate) : ('Not Active' | translate)}}\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        {{prob.Duration ? prob.Duration : '-----'}}\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span ng-if=\"!prob.Notes\">-----</span>\r" +
    "\n" +
    "            <span ng-if=\"prob.Notes && prob.Show\">\r" +
    "\n" +
    "              {{::'Hide' | translate}}&nbsp;\r" +
    "\n" +
    "              <i class=\"fa fa-angle-double-up\"></i>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "            <span ng-if=\"prob.Notes && !prob.Show\">\r" +
    "\n" +
    "              {{::'View' | translate}}&nbsp;\r" +
    "\n" +
    "              <i class=\"fa fa-angle-double-down\"></i>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                <tr ng-show=\"prob.Show\" ng-repeat-end>\r" +
    "\n" +
    "                    <td class=\"ap-problems-notes\" colspan=\"5\">\r" +
    "\n" +
    "                        {{prob.Notes}}\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </tbody>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-cloak ng-show=\"httpError.unhandled\">\r" +
    "\n" +
    "                {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-cloak ng-show=\"httpError.is403\" translate>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s info.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/procedures.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"procedures-panel\" class=\"panel panel-default panel-flush table-responsive\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Procedures' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"table-responsive\">\r" +
    "\n" +
    "            <div ng-if=\"!procedures.length\">\r" +
    "\n" +
    "                {{::'No procedures were found' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <table id=\"procedures-table\" class=\"table table-striped\" ng-if=\"procedures.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                <tr>\r" +
    "\n" +
    "                    <th>{{::'Procedure' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Date' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Description' | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::'Notes' | translate}}</th>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "                <tbody>\r" +
    "\n" +
    "                <tr ng-repeat=\"proc in procedures\" ng-click=\"hidden(proc)\"\r" +
    "\n" +
    "                    ng-class=\"{'clickable' : proc.Notes || proc.Long}\">\r" +
    "\n" +
    "                    <td>{{::proc.Name}}</td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{proc.VisitDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"desc-container\">\r" +
    "\n" +
    "                            <div class=\"ng-hide overflow-ellipsis\" ng-class=\"{'overflow-ellipsis': !proc.Show}\"\r" +
    "\n" +
    "                                 ng-show=\"proc.Description\">\r" +
    "\n" +
    "                                <span>{{::proc.Description}}</span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"smaller\">\r" +
    "\n" +
    "                            <span ng-if=\"!proc.Notes && !proc.Long\">-----</span>\r" +
    "\n" +
    "                  <span ng-if=\"(proc.Notes || proc.Long) && proc.Show\">\r" +
    "\n" +
    "                    {{::'Hide' | translate}}&nbsp;<i class=\"fa fa-angle-double-up\"></i>\r" +
    "\n" +
    "                  </span>\r" +
    "\n" +
    "                  <span ng-if=\"(proc.Notes || proc.Long) && !proc.Show\">\r" +
    "\n" +
    "                    {{::'View' | translate}}&nbsp;<i class=\"fa fa-angle-double-down\"></i>\r" +
    "\n" +
    "                  </span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </tbody>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12\" ng-if=\"false\">\r" +
    "\n" +
    "                <div class=\"col-xs-10\">\r" +
    "\n" +
    "                    Viewing&nbsp;<u><a href=\"#\" onClick=\"return false;\">{{procedures.length}} Diagnosis</a></u>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"pull-right\">\r" +
    "\n" +
    "                    <a href=\"#\" onClick=\"return false;\">&lt;</a>&nbsp;<a\r" +
    "\n" +
    "                        href=\"#\" onClick=\"return false;\">1</a>&nbsp;<a\r" +
    "\n" +
    "                        href=\"#\" onClick=\"return false;\">&gt;</a>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s info.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/mychart/views/referenceMaterial.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"reference-material-panel\" class=\"panel panel-default panel-flush\"\r" +
    "\n" +
    "         ng-class=\"(isModalDisplayed)?'hidden-print':''\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Educational Material' | translate}}\r" +
    "\n" +
    "            <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "                <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" id=\"vaccinecardtype-filter-btn\"\r" +
    "\n" +
    "                            uib-dropdown-toggle>\r" +
    "\n" +
    "                        {{ 'Language' | translate }}&nbsp;&nbsp;\r" +
    "\n" +
    "                        <span class=\"title-text\">{{ model.ActiveLanguage.Description }}</span>\r" +
    "\n" +
    "                        <span class=\"caret\"></span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu>\r" +
    "\n" +
    "                        <li class=\"clickable\" role=\"presentation\" ng-repeat=\"language in model.LanguageOptions\">\r" +
    "\n" +
    "                            <a ng-if=\"language\" role=\"menuitem\"\r" +
    "\n" +
    "                               ng-click=\"updateActiveLanguage(language)\">{{ ::language.Description }}</a>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\">\r" +
    "\n" +
    "            <div ng-if=\"!model.EducationalMaterial.length\">\r" +
    "\n" +
    "                {{::'No Educational Material found.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <table id=\"reference-material-table\" class=\"table table-striped\" ng-if=\"model.EducationalMaterial.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                    <tr>\r" +
    "\n" +
    "                        <th>{{::\"Description\" | translate}}</th>\r" +
    "\n" +
    "                        <th>{{::\"Available Languages\" | translate}}</th>\r" +
    "\n" +
    "                        <th></th>\r" +
    "\n" +
    "                        <th></th>\r" +
    "\n" +
    "                    </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "                <tbody>\r" +
    "\n" +
    "                    <tr ng-repeat=\"formGroup in model.EducationalMaterial track by $index\" ng-if=\"formGroup\">\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div>{{::formGroup.GroupName}}</div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <span ng-repeat=\"refForm in formGroup.Forms track by $index\">{{::refForm.Language.Description}}<span\r" +
    "\n" +
    "                                    ng-if=\"!$last\">,&nbsp;</span></span>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-1 col-flush\">\r" +
    "\n" +
    "                                    <i class=\"fa fa-file fa-lg\"></i>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-11 col-flush float-left\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-text\">\r" +
    "\n" +
    "                                        <a ng-click=\"viewReferenceMaterial(formGroup.GroupName, formGroup.Forms)\">\r" +
    "\n" +
    "                                            <span class=\"underline-text\">{{::'View Form' | translate}}</span>\r" +
    "\n" +
    "                                        </a>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"col-xs-12 column-subtext\">\r" +
    "\n" +
    "                                        {{::attachmentInfo.Extension | uppercase}}\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                        <td>\r" +
    "\n" +
    "                            <button ap-save-to-file=\"downloadForm(formGroup)\"\r" +
    "\n" +
    "                                    file-name=\"{{formGroup.GroupName}}\"\r" +
    "\n" +
    "                                    ><i ng-show=\"!formGroup.Downloading\" class=\"fa fa-download\"></i><ap-spinner ng-show=\"formGroup.Downloading\"></ap-spinner></button>\r" +
    "\n" +
    "                        </td>\r" +
    "\n" +
    "                    </tr>\r" +
    "\n" +
    "                </tbody>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s info.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/shareCCD.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-share chart-label\">\r" +
    "\n" +
    "        <div class=\"panel-heading panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-title text-center\">{{::'Continuity Care Document' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"ap-checkbox-flush ap-checkbox-center-h\">\r" +
    "\n" +
    "                        <input type=\"checkbox\" id=\"full-history\" ng-model=\"vm.fullHistory\"\r" +
    "\n" +
    "                                ap-checkbox-label=\"{{'Complete History' | translate}}\">\r" +
    "\n" +
    "                        <button class=\"btn btn-primary btn-add-padding\" ng-click=\"getCcdHtml()\">\r" +
    "\n" +
    "                            {{::'Refresh' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <button class=\"btn btn-default1 btn-add-padding\" ng-click=\"transmitModal()\">\r" +
    "\n" +
    "                            {{::'Transmit' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                        <button class=\"btn btn-default btn-add-padding\" ng-click=\"viewAccessLog()\">\r" +
    "\n" +
    "                            {{::'View Access Log' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"ccd-start-date\">{{::'From' | translate}}</label>\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <input class=\"form-control label_wrap\" \r" +
    "\n" +
    "                        id=\"ccd-start-date\"\r" +
    "\n" +
    "                        type=\"date\"\r" +
    "\n" +
    "                        min=\"1900-01-01\"\r" +
    "\n" +
    "                        max=\"9998-12-31\"\r" +
    "\n" +
    "                        ng-model=\"vm.startDate\"\r" +
    "\n" +
    "                        ng-disabled=\"vm.fullHistory\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                    <label class=\"control-label\" for=\"ccd-end-date\">{{::'To' | translate}}</label>\r" +
    "\n" +
    "                    <div class=\"form-group\">\r" +
    "\n" +
    "                        <input class=\"form-control label_wrap\" \r" +
    "\n" +
    "                        id=\"ccd-end-date\"\r" +
    "\n" +
    "                        type=\"date\"\r" +
    "\n" +
    "                        min=\"1900-01-01\"\r" +
    "\n" +
    "                        max=\"9998-12-31\"\r" +
    "\n" +
    "                        ng-model=\"vm.endDate\"\r" +
    "\n" +
    "                        ng-disabled=\"vm.fullHistory\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            \r" +
    "\n" +
    "            <div class=\"text-center\" ng-if=\"loadingCcd\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row\" ng-if=\"!loadingCcd\">\r" +
    "\n" +
    "                <div class=\"panel-subheading flexbox flexbox-horizontal-center\">\r" +
    "\n" +
    "                    {{::'Document Preview' | translate}}\r" +
    "\n" +
    "                    <span class=\"flexbox-pull-right\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default\"\r" +
    "\n" +
    "                                ng-disabled=\"loadingHtml\"\r" +
    "\n" +
    "                                ap-save-string-to-file=\"downloadHtml()\"\r" +
    "\n" +
    "                                file-name=\"{{model.ccdFileName}}\">\r" +
    "\n" +
    "                                <span class=\"ng-hide\" ng-show=\"loadingHtml\">\r" +
    "\n" +
    "                                    <ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                            <span><i class=\"fa fa-download\"></i></span>\r" +
    "\n" +
    "                            {{::'Html' | translate}}\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    <button class=\"btn btn-default\"\r" +
    "\n" +
    "                            ng-disabled=\"loadingXml\"\r" +
    "\n" +
    "                            ap-save-string-to-file=\"downloadCDA()\"\r" +
    "\n" +
    "                            file-name=\"{{model.xmlFileName}}\">\r" +
    "\n" +
    "                            <span class=\"ng-hide\" ng-show=\"loadingXml\">\r" +
    "\n" +
    "                                    <ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                        <span><i class=\"fa fa-download\"></i></span>\r" +
    "\n" +
    "                        {{::'CDA' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div ng-if=\"!loadingCcd\">\r" +
    "\n" +
    "                    <ap-dynamic-frame\r" +
    "\n" +
    "                    html=\"model.chartHtml\"\r" +
    "\n" +
    "                    loading-Url=\"model.loadingUrl\">\r" +
    "\n" +
    "                    </ap-dynamic-frame>\r" +
    "\n" +
    "            </div>            \r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-if=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-if=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to this patient\\'s info.'| translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/mychart/views/visitSummary.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"visit-summary-panel\" class=\"panel panel-default panel-flush\" ng-class=\"(isModalDisplayed)?'hidden-print':''\">\r" +
    "\n" +
    "        <div class=\"panel-heading\">\r" +
    "\n" +
    "            {{::'Visit Summary' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"table-responsive\">\r" +
    "\n" +
    "            <div ng-if=\"!visits.length\">\r" +
    "\n" +
    "                {{::'No completed Visit Summaries were found' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <table id=\"visit-summary-table\" class=\"table table-striped\" ng-if=\"visits.length\">\r" +
    "\n" +
    "                <thead>\r" +
    "\n" +
    "                <tr>\r" +
    "\n" +
    "                    <th>{{::\"Date\" | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::\"Clinical Note Type\" | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::\"Diagnoses\" | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::\"Provider\" | translate}}</th>\r" +
    "\n" +
    "                    <th>{{::\"Summary\" | translate}}</th>\r" +
    "\n" +
    "                    <th></th>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "                </thead>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <tr ng-repeat=\"visit in visits\">\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{::visit.Date}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span class=\"column-text\">{{::visit.ClinicalNoteTypeName}}</span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"column-text\" ng-repeat=\"diagnoses in ::visit.Diagnoses\">\r" +
    "\n" +
    "                            {{::diagnoses.Name}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <span class=\"column-text\">{{::visit.Provider}}</span>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <div class=\"col-xs-1 col-flush\">\r" +
    "\n" +
    "                            <i class=\"fa fa-file fa-lg\"></i>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-11 col-flush float-left\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 column-text\">\r" +
    "\n" +
    "                                <a ng-click=\"viewVisitSummary(visit.VisitId, visit.Date)\"><u>{{::'View Summary' | translate}}</u></a>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <td>\r" +
    "\n" +
    "                        <button ap-save-to-file=\"downloadVisitSummaryByVisit(visit, visit.Date)\"><i ng-show=\"!visit.Downloading\" class=\"fa fa-download\"></i><ap-spinner ng-show=\"visit.Downloading\"></ap-spinner></button>\r" +
    "\n" +
    "                    </td>\r" +
    "\n" +
    "                </tr>\r" +
    "\n" +
    "            </table>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient info could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak translate>\r" +
    "\n" +
    "                {{::'You do not have access to this patient\\'s info.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
